import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';
import { translate } from 'i18n/jhipster-language';
import PCol from 'shared/ui/pcol';
import PRow from 'shared/ui/prow';
import { getEntities, clearMutationFlags, } from 'shared/lib/reducers/card-replacement-request.reducer';
import { APP_LOCAL_DATETIME_FORMAT, ROWS_PER_PAGE } from 'app/config/constants';
import moment from 'moment';
import { isTableSkeletonRow, TABLE_SKELETON_ROW_COUNT, tableActionButtonsSkeleton, tableCellSkeleton, } from 'shared/ui/table-skeleton';
import { CARD_REPLACEMENT_STATUS_FILTER_OPTIONS } from 'shared/lib/card-replacement-list.constants';
import CardReplacementRequestListCreateDialog from './card-replacement-request-list-create-dialog';
import CardReplacementRequestDetailDialog from './card-replacement-request-detail-dialog';
import CardReplacementRequestApproveDialog from './card-replacement-request-approve-dialog';
import CardDataPreview from 'shared/ui/naqdpay-card/NaqdPayCard';
import { validateDateRanges } from 'shared/lib/validation/search-filters';
const appendEnumFieldCriteria = (params, field, op, single, multi, specified) => {
    switch (op) {
        case 'equals':
            if (single)
                params[`${field}.equals`] = single;
            break;
        case 'notEquals':
            if (single)
                params[`${field}.notEquals`] = single;
            break;
        case 'specified':
            if (specified === true || specified === false)
                params[`${field}.specified`] = specified;
            break;
        case 'in':
            if (multi.length)
                params[`${field}.in`] = [...multi];
            break;
        case 'notIn':
            if (multi.length)
                params[`${field}.notIn`] = [...multi];
            break;
        default:
            break;
    }
};
const rangeDateToIso = (d, endOfDay) => {
    if (!d)
        return null;
    const m = moment(d);
    return (endOfDay ? m.endOf('day') : m.startOf('day')).toISOString();
};
const buildSkeletonRows = () => Array.from({ length: TABLE_SKELETON_ROW_COUNT }, (_, i) => ({ id: -(i + 1) }));
const formatDt = (v) => (v ? moment(v).format(APP_LOCAL_DATETIME_FORMAT) : '');
const statusSeverity = (s) => {
    if (!s)
        return null;
    if (s === 'APPROVED' || s === 'COMPLETED')
        return 'success';
    if (s === 'REJECTED' || s === 'CANCELLED')
        return 'danger';
    return 'warning';
};
const canApproveRow = (row) => row.status === 'REQUESTED' || row.status === 'PENDING' || row.status === 'SUBMITTED';
const dash = (v) => v != null && String(v).trim() !== '' ? String(v) : '—';
/** Groups PAN (masked or full) for display on the faux physical card. */
const formatPanForCard = (pan) => {
    const s = pan?.trim();
    if (!s)
        return '•••• •••• •••• ••••';
    const compact = s.replace(/\s+/g, '');
    let out = '';
    for (let i = 0; i < compact.length; i += 4) {
        if (i)
            out += ' ';
        out += compact.slice(i, i + 4);
    }
    return out;
};
const formatExpiryMmYy = (iso) => {
    if (!iso?.trim())
        return '--/--';
    const m = moment(iso);
    return m.isValid() ? m.format('MM/YY') : '--/--';
};
const allowRowExpansion = (row) => !isTableSkeletonRow(row);
const mapState = ({ cardReplacementRequest }) => ({
    entities: cardReplacementRequest.entities,
    totalItems: cardReplacementRequest.totalItems,
    loading: cardReplacementRequest.loading,
    updateSuccess: cardReplacementRequest.updateSuccess,
});
const mapDispatch = {
    loadList: getEntities,
    clearFlags: clearMutationFlags,
};
export const CardReplacementRequestsList = ({ entities, totalItems, loading, updateSuccess, loadList, clearFlags, }) => {
    const navigate = useNavigate();
    const [listPage, setListPage] = useState(0);
    const [listFirst, setListFirst] = useState(0);
    const [showAdvanced, setShowAdvanced] = useState(false);
    const [showCreate, setShowCreate] = useState(false);
    const [detailRow, setDetailRow] = useState(null);
    const [approveRow, setApproveRow] = useState(null);
    const [expandedRows, setExpandedRows] = useState(undefined);
    const [draftStatusOp, setDraftStatusOp] = useState('equals');
    const [draftStatusSingle, setDraftStatusSingle] = useState(null);
    const [draftStatusMulti, setDraftStatusMulti] = useState([]);
    const [draftStatusSpecified, setDraftStatusSpecified] = useState(null);
    const [draftReasonOp, setDraftReasonOp] = useState('equals');
    const [draftReasonSingle, setDraftReasonSingle] = useState(null);
    const [draftReasonMulti, setDraftReasonMulti] = useState([]);
    const [draftReasonSpecified, setDraftReasonSpecified] = useState(null);
    const [draftRequestedAtFrom, setDraftRequestedAtFrom] = useState(null);
    const [draftRequestedAtTo, setDraftRequestedAtTo] = useState(null);
    const [draftProcessedAtFrom, setDraftProcessedAtFrom] = useState(null);
    const [draftProcessedAtTo, setDraftProcessedAtTo] = useState(null);
    const [appliedStatusOp, setAppliedStatusOp] = useState('equals');
    const [appliedStatusSingle, setAppliedStatusSingle] = useState(null);
    const [appliedStatusMulti, setAppliedStatusMulti] = useState([]);
    const [appliedStatusSpecified, setAppliedStatusSpecified] = useState(null);
    const [appliedReasonOp, setAppliedReasonOp] = useState('equals');
    const [appliedReasonSingle, setAppliedReasonSingle] = useState(null);
    const [appliedReasonMulti, setAppliedReasonMulti] = useState([]);
    const [appliedReasonSpecified, setAppliedReasonSpecified] = useState(null);
    const [appliedRequestedAtFrom, setAppliedRequestedAtFrom] = useState(null);
    const [appliedRequestedAtTo, setAppliedRequestedAtTo] = useState(null);
    const [appliedProcessedAtFrom, setAppliedProcessedAtFrom] = useState(null);
    const [appliedProcessedAtTo, setAppliedProcessedAtTo] = useState(null);
    const listParams = useMemo(() => {
        const params = {
            page: listPage,
            size: ROWS_PER_PAGE,
        };
        appendEnumFieldCriteria(params, 'status', appliedStatusOp, appliedStatusSingle, appliedStatusMulti, appliedStatusSpecified);
        appendEnumFieldCriteria(params, 'reason', appliedReasonOp, appliedReasonSingle, appliedReasonMulti, appliedReasonSpecified);
        const reqGte = rangeDateToIso(appliedRequestedAtFrom, false);
        if (reqGte)
            params['requestedAt.greaterThanOrEqual'] = reqGte;
        const reqLte = rangeDateToIso(appliedRequestedAtTo, true);
        if (reqLte)
            params['requestedAt.lessThanOrEqual'] = reqLte;
        const procGte = rangeDateToIso(appliedProcessedAtFrom, false);
        if (procGte)
            params['processedAt.greaterThanOrEqual'] = procGte;
        const procLte = rangeDateToIso(appliedProcessedAtTo, true);
        if (procLte)
            params['processedAt.lessThanOrEqual'] = procLte;
        return params;
    }, [
        listPage,
        appliedStatusOp,
        appliedStatusSingle,
        appliedStatusMulti,
        appliedStatusSpecified,
        appliedReasonOp,
        appliedReasonSingle,
        appliedReasonMulti,
        appliedReasonSpecified,
        appliedRequestedAtFrom,
        appliedRequestedAtTo,
        appliedProcessedAtFrom,
        appliedProcessedAtTo,
    ]);
    const fetchPage = useCallback(() => {
        loadList(listParams);
    }, [loadList, listParams]);
    useEffect(() => {
        fetchPage();
    }, [fetchPage]);
    useEffect(() => {
        setExpandedRows(undefined);
    }, [listPage]);
    useEffect(() => {
        if (!updateSuccess)
            return;
        fetchPage();
        clearFlags();
    }, [updateSuccess, fetchPage, clearFlags]);
    const filterDateRangeError = validateDateRanges([
        { start: draftRequestedAtFrom, end: draftRequestedAtTo },
        { start: draftProcessedAtFrom, end: draftProcessedAtTo },
    ]);
    const onApplyFilters = () => {
        if (filterDateRangeError)
            return;
        setAppliedStatusOp(draftStatusOp);
        setAppliedStatusSingle(draftStatusSingle);
        setAppliedStatusMulti(draftStatusMulti.slice());
        setAppliedStatusSpecified(draftStatusSpecified);
        setAppliedReasonOp(draftReasonOp);
        setAppliedReasonSingle(draftReasonSingle);
        setAppliedReasonMulti(draftReasonMulti.slice());
        setAppliedReasonSpecified(draftReasonSpecified);
        setAppliedRequestedAtFrom(draftRequestedAtFrom);
        setAppliedRequestedAtTo(draftRequestedAtTo);
        setAppliedProcessedAtFrom(draftProcessedAtFrom);
        setAppliedProcessedAtTo(draftProcessedAtTo);
        setListPage(0);
        setListFirst(0);
    };
    const onClearFilters = () => {
        setDraftStatusOp('equals');
        setDraftStatusSingle(null);
        setDraftStatusMulti([]);
        setDraftStatusSpecified(null);
        setDraftReasonOp('equals');
        setDraftReasonSingle(null);
        setDraftReasonMulti([]);
        setDraftReasonSpecified(null);
        setDraftRequestedAtFrom(null);
        setDraftRequestedAtTo(null);
        setDraftProcessedAtFrom(null);
        setDraftProcessedAtTo(null);
        setAppliedStatusOp('equals');
        setAppliedStatusSingle(null);
        setAppliedStatusMulti([]);
        setAppliedStatusSpecified(null);
        setAppliedReasonOp('equals');
        setAppliedReasonSingle(null);
        setAppliedReasonMulti([]);
        setAppliedReasonSpecified(null);
        setAppliedRequestedAtFrom(null);
        setAppliedRequestedAtTo(null);
        setAppliedProcessedAtFrom(null);
        setAppliedProcessedAtTo(null);
        setListPage(0);
        setListFirst(0);
    };
    const criteriaOpOptions = useMemo(() => [
        { name: translate('general.filter.equals'), value: 'equals' },
        { name: translate('general.filter.notEquals'), value: 'notEquals' },
        { name: translate('general.filter.specified'), value: 'specified' },
        { name: translate('general.filter.in'), value: 'in' },
        { name: translate('general.filter.notIn'), value: 'notIn' },
    ], []);
    const specifiedPresenceOptions = useMemo(() => [
        { name: translate('general.filter.specifiedPresent'), value: true },
        { name: translate('general.filter.specifiedAbsent'), value: false },
    ], []);
    const t = {
        cms: translate('form.cms'),
        title: translate('form.cardReplacementRequests'),
        create: translate('entity.action.create', { entity: translate('form.cardReplacementRequest') }),
        empty: translate('general.dtEmptymessage'),
        search: translate('entity.action.search'),
        clear: translate('general.reset'),
        advancedToggle: translate('general.advancedSearch.toggle'),
        id: translate('form.id'),
        cardReference: translate('form.cardReference'),
        reasonLabel: translate('form.reasonLabel'),
        status: translate('form.status'),
        requestedAt: translate('form.requestedAt'),
        actions: translate('general.actions'),
        approve: translate('form.action.approve'),
        view: translate('entity.action.view'),
        filterStatus: translate('form.status'),
        filterReason: translate('form.replacementReason'),
        criteriaMatchMode: translate('form.criteriaMatchMode'),
        requestedAtFromLabel: `${translate('form.requestedAt')} — ${translate('general.from')}`,
        requestedAtToLabel: `${translate('form.requestedAt')} — ${translate('general.to')}`,
        processedAtFromLabel: `${translate('form.processedAt')} — ${translate('general.from')}`,
        processedAtToLabel: `${translate('form.processedAt')} — ${translate('general.to')}`,
        replacementOldDetails: translate('form.replacementOldCardDetails'),
        replacementNewDetails: translate('form.replacementNewCardDetails'),
        expandAllRows: translate('form.tableExpandAll'),
        collapseAllRows: translate('form.tableCollapseAll'),
        cardSummaryShort: translate('form.cardSummaryShort'),
        processedAt: translate('form.processedAt'),
        sourceChannel: translate('form.sourceChannel'),
        performedBy: translate('form.performedBy'),
    };
    const expandAllOnPage = () => {
        if (loading)
            return;
        const next = {};
        entities.forEach(r => {
            if (r.id != null && typeof r.id === 'number' && r.id > 0)
                next[String(r.id)] = true;
        });
        setExpandedRows(next);
    };
    const collapseAllExpanded = () => setExpandedRows(undefined);
    const cardDetailBlock = (title, card, fallbackId) => {
        const holder = card?.cardHolderName?.trim()
            ? card.cardHolderName.trim().toUpperCase()
            : 'CARDHOLDER NAME';
        return (_jsxs("div", { children: [_jsx("div", { className: "p-mb-2 p-text-bold", children: title }), _jsx(CardDataPreview, { cardHolderName: holder, cardNumber: formatPanForCard(card?.maskedPan), validThru: formatExpiryMmYy(card?.expiryDate) }), _jsxs("div", { className: "p-mt-2 p-text-sm", style: { maxWidth: 370 }, children: [_jsx("span", { className: "p-text-muted", children: t.id }), " ", dash(card?.id ?? fallbackId), ' · ', _jsx("span", { className: "p-text-muted", children: t.cardReference }), " ", dash(card?.cardReference)] })] }));
    };
    const rowExpansionTemplate = (data) => (_jsxs("div", { className: "p-3", children: [_jsxs(PRow, { className: "p-ai-stretch", children: [_jsx(PCol, { col: 12, md: 6, children: cardDetailBlock(t.replacementOldDetails, data.oldCard, data.oldCardId) }), _jsx(PCol, { col: 12, md: 6, children: cardDetailBlock(t.replacementNewDetails, data.newCard, data.newCardId) })] }), _jsxs(PRow, { className: "p-mt-2 p-ai-start", children: [_jsxs(PCol, { col: 12, md: 4, className: "p-field p-mb-0", children: [_jsx("span", { className: "p-text-muted p-text-sm", children: t.sourceChannel }), _jsx("div", { children: dash(data.sourceChannel) })] }), _jsxs(PCol, { col: 12, md: 4, className: "p-field p-mb-0", children: [_jsx("span", { className: "p-text-muted p-text-sm", children: t.performedBy }), _jsx("div", { children: dash(data.performedBy) })] }), _jsxs(PCol, { col: 12, md: 4, className: "p-field p-mb-0", children: [_jsx("span", { className: "p-text-muted p-text-sm", children: t.processedAt }), _jsx("div", { children: formatDt(data.processedAt) })] })] })] }));
    const advancedPanel = (_jsxs("div", { className: "p-mt-3 p-p-3", style: { background: 'var(--surface-50, #fafafa)', borderRadius: '8px' }, children: [_jsx(PRow, { className: "p-ai-end", children: _jsx(PCol, { col: 12, className: "p-mb-2 p-text-bold", children: t.filterStatus }) }), _jsxs(PRow, { className: "p-ai-end", children: [_jsxs(PCol, { col: 12, md: 6, lg: 3, className: "p-field", children: [_jsx("label", { htmlFor: "replacement-filter-status-val", children: t.filterStatus }), draftStatusOp === 'equals' || draftStatusOp === 'notEquals' ? (_jsx(Dropdown, { inputId: "replacement-filter-status-val", className: "w-full", options: CARD_REPLACEMENT_STATUS_FILTER_OPTIONS, optionLabel: "name", optionValue: "value", value: draftStatusSingle, onChange: e => setDraftStatusSingle(e.value), showClear: true, placeholder: "\u2014" })) : draftStatusOp === 'specified' ? (_jsx(Dropdown, { inputId: "replacement-filter-status-val", className: "w-full", options: specifiedPresenceOptions, optionLabel: "name", optionValue: "value", value: draftStatusSpecified, onChange: e => setDraftStatusSpecified(e.value), showClear: true, placeholder: "\u2014" })) : (_jsx(MultiSelect, { inputId: "replacement-filter-status-val", className: "w-full", display: "chip", options: CARD_REPLACEMENT_STATUS_FILTER_OPTIONS, optionLabel: "name", optionValue: "value", value: draftStatusMulti, onChange: e => setDraftStatusMulti(e.value ?? []), placeholder: "\u2014" }))] }), _jsxs(PCol, { col: 12, md: 4, lg: 3, className: "p-field", children: [_jsx("label", { htmlFor: "replacement-filter-requested-from", children: t.requestedAtFromLabel }), _jsx(Calendar, { id: "replacement-filter-requested-from", className: "w-full", value: draftRequestedAtFrom, onChange: e => setDraftRequestedAtFrom(e.value), showButtonBar: true, dateFormat: "yy-mm-dd", invalid: !!filterDateRangeError })] }), _jsxs(PCol, { col: 12, md: 4, lg: 3, className: "p-field", children: [_jsx("label", { htmlFor: "replacement-filter-requested-to", children: t.requestedAtToLabel }), _jsx(Calendar, { id: "replacement-filter-requested-to", className: "w-full", value: draftRequestedAtTo, onChange: e => setDraftRequestedAtTo(e.value), showButtonBar: true, dateFormat: "yy-mm-dd", invalid: !!filterDateRangeError })] }), _jsxs(PCol, { col: 12, md: 4, lg: 3, className: "p-field", children: [_jsx("label", { htmlFor: "replacement-filter-processed-from", children: t.processedAtFromLabel }), _jsx(Calendar, { id: "replacement-filter-processed-from", className: "w-full", value: draftProcessedAtFrom, onChange: e => setDraftProcessedAtFrom(e.value), showButtonBar: true, dateFormat: "yy-mm-dd", invalid: !!filterDateRangeError })] })] }), _jsx(PRow, { className: "p-ai-end p-mt-2", children: _jsxs(PCol, { col: 12, md: 4, lg: 3, className: "p-field", children: [_jsx("label", { htmlFor: "replacement-filter-processed-to", children: t.processedAtToLabel }), _jsx(Calendar, { id: "replacement-filter-processed-to", className: "w-full", value: draftProcessedAtTo, onChange: e => setDraftProcessedAtTo(e.value), showButtonBar: true, dateFormat: "yy-mm-dd", invalid: !!filterDateRangeError }), filterDateRangeError ? _jsx("small", { className: "p-error", children: filterDateRangeError }) : null] }) }), _jsxs(PRow, { className: "p-mt-2 p-jc-end", style: { gap: '0.5rem' }, children: [_jsx(Button, { type: "button", icon: "pi pi-search", label: t.search, onClick: onApplyFilters, disabled: !!filterDateRangeError }), _jsx(Button, { type: "button", icon: "pi pi-times", className: "p-button-secondary", label: t.clear, onClick: onClearFilters })] })] }));
    const tableHeader = (_jsxs("div", { style: { width: '100%' }, children: [_jsxs("div", { className: "p-d-flex p-jc-between p-ai-start p-flex-wrap", style: { gap: '0.75rem' }, children: [_jsxs("div", { className: "p-d-flex p-ai-center p-flex-wrap", style: { gap: '0.5rem' }, children: [_jsx(Button, { type: "button", icon: "pi pi-plus", label: t.create, onClick: () => setShowCreate(true) }), _jsx(Button, { type: "button", icon: "pi pi-angle-down", className: "p-button-text", label: t.expandAllRows, disabled: loading || entities.length === 0, onClick: expandAllOnPage }), _jsx(Button, { type: "button", icon: "pi pi-angle-up", className: "p-button-text", label: t.collapseAllRows, disabled: !expandedRows || Object.keys(expandedRows).length === 0, onClick: collapseAllExpanded })] }), _jsx(Button, { type: "button", icon: showAdvanced ? 'pi pi-chevron-up' : 'pi pi-chevron-down', className: "p-button-outlined", label: t.advancedToggle, onClick: () => setShowAdvanced(s => !s) })] }), showAdvanced ? advancedPanel : null] }));
    const tableValue = loading ? buildSkeletonRows() : entities.slice();
    const actionBody = (row) => isTableSkeletonRow(row) ? (tableActionButtonsSkeleton({ buttonCount: 2 })) : (_jsxs(PRow, { children: [_jsx(Button, { type: "button", icon: "pi pi-eye", className: "p-button-primary p-mr-1", onClick: () => setDetailRow(row), "aria-label": t.view }), _jsx(Button, { type: "button", icon: "pi pi-check", className: "p-button-success p-mr-1", disabled: !canApproveRow(row), onClick: () => setApproveRow(row), "aria-label": t.approve, title: t.approve })] }));
    return (_jsxs(PRow, { style: { width: '100%' }, className: "p-mt-2 p-px-2", children: [_jsx(PCol, { col: "12", children: _jsx(BreadCrumb, { home: { icon: 'pi pi-home', command: () => navigate('/') }, model: [{ label: t.cms }, { label: t.title }] }) }), _jsx(PCol, { col: "12", className: "mt-4", children: _jsxs(DataTable, { dataKey: "id", lazy: true, header: tableHeader, value: tableValue, expandedRows: expandedRows, onRowToggle: e => {
                        const data = e.data;
                        setExpandedRows(Object.keys(data ?? {}).length ? data : undefined);
                    }, rowExpansionTemplate: rowExpansionTemplate, first: listFirst, paginator: !loading && totalItems > ROWS_PER_PAGE, rows: ROWS_PER_PAGE, totalRecords: totalItems, onPage: (e) => {
                        setListFirst(e.first ?? 0);
                        setListPage(e.page ?? 0);
                    }, selectionMode: "single", isDataSelectable: e => !isTableSkeletonRow(e.data), resizableColumns: true, emptyMessage: t.empty, children: [_jsx(Column, { expander: allowRowExpansion, style: { width: '3rem' } }), _jsx(Column, { field: "id", header: t.id, body: r => isTableSkeletonRow(r)
                                ? tableCellSkeleton()
                                : String(r.id ?? '') }), _jsx(Column, { header: t.cardSummaryShort, body: r => {
                                if (isTableSkeletonRow(r))
                                    return tableCellSkeleton();
                                const row = r;
                                return `${dash(row.oldCard?.maskedPan)} → ${dash(row.newCard?.maskedPan)}`;
                            } }), _jsx(Column, { header: t.reasonLabel, body: r => isTableSkeletonRow(r)
                                ? tableCellSkeleton()
                                : (r.reason ?? '') }), _jsx(Column, { header: t.status, body: r => {
                                if (isTableSkeletonRow(r))
                                    return tableCellSkeleton();
                                const s = r.status ?? '';
                                return _jsx(Tag, { value: s, severity: statusSeverity(s) ?? undefined });
                            } }), _jsx(Column, { header: t.requestedAt, body: r => isTableSkeletonRow(r)
                                ? tableCellSkeleton()
                                : formatDt(r.requestedAt) }), _jsx(Column, { header: t.actions, style: { width: '120px' }, body: actionBody })] }) }), _jsx(CardReplacementRequestListCreateDialog, { visible: showCreate, onHide: () => setShowCreate(false), onCreated: fetchPage }), _jsx(CardReplacementRequestDetailDialog, { visible: detailRow != null, row: detailRow, onHide: () => setDetailRow(null) }), _jsx(CardReplacementRequestApproveDialog, { visible: approveRow != null, row: approveRow, onHide: () => setApproveRow(null), onApproved: fetchPage })] }));
};
export default connect(mapState, mapDispatch)(CardReplacementRequestsList);
